import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import './style.css'

import App from './App.vue'
import router from './router'

const app = createApp(App)

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
  ],
  tracesSampleRate: 0.2,
  environment: import.meta.env.MODE,
  release: __APP_VERSION__,
  enabled: import.meta.env.PROD,
})
app.use(createPinia())
app.use(router)

app.mount('#app')
